import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { Alert, Button, Col, Container, Input, Row } from 'reactstrap';
import styled from 'styled-components';
import CustomNavbar from '../components/CustomNavbar';
import axios from 'axios'

const SignUp = () => {

  const navigate = useNavigate();

  const [data, setData] = useState({ fullName: "", email: "", password: "" })
  const [colorV, setColorV] = useState("warning")
  const [message, setMessage] = useState("")

  const headers = {
    'Content-Type': 'text/plain',
    'Access-Control-Allow-Origin': '*'
  };

  const signUpUser = (event) => {
    event.preventDefault();
    setMessage("processing")
    axios.post(`https://api.xploreux.techlife-center.com/api/v1/signup`, data, headers)
      .then(res => {
        console.log(res?.data)
        setMessage(res?.data?.message)
        setColorV("success")

      })
      .catch(error => {
        const errors = error?.response?.data
        const obj = Object.values(errors?.errors);
        setMessage(obj? obj[0]:errors?.message)
        setColorV("danger")

      });

  }

  const handleChange = (event) => {
    setData({ ...data, [event.target.name]: event.target.value })
  }


  return (
    <>
      <CustomNavbar colorV="#F5F4FA" navC="light" pos="top" />
      <Container className="d-flex align-items-center justify-content-center" fluid style={{ background: "#F5F4FA", minHeight: "100vh" }}>
        <div className="bg-white rounded-lg shadow-sm p-4 p-md-5">
          <Container style={{ minWidth: "40vw" }}>
            <Row className="head text-primary justify-content-center text-center pt-5 pb-4">
              <Col xs={6} md={4}>
                <h4 className="mb-0 hoverPointer" style={{ opacity: "0.6" }} onClick={() => navigate('/login')}>LOGIN</h4>
              </Col>
              <Col xs={6} md={4}>
                <h4 className="mb-0 hoverPointer">SIGN UP</h4>
              </Col>
            </Row>
            <Row>
              <Col md={{ offset: 1, size: 10 }}>
                <form onSubmit={message !="processing"?signUpUser:''}>
                  <Input type="text" name="fullName" onChange={handleChange} value={data.fullName} placeholder="Username" required className="bg-gray rounded-pill my-2 mb-3  text-secondary border-1" />
                  <Input type="email" name="email" onChange={handleChange} value={data.email} placeholder="Email Id" autoFocus required className="rounded-pill mb-3 my-2 text-secondary border-1" />
                  <Input type="password" name="password" onChange={handleChange} value={data.password} placeholder="Password" required className=" rounded-pill my-2 mt-4 text-secondary border-1" />
                  <Button className="rounded-pill my-2 mt-4 py-2 w-100 border-0" type={message !="processing"?"submit":'button'} color="primary">{message !="processing"?"Sign Up":'Please Wait...'}</Button>
                </form>
                <p className="head mb-0 text-secondary my-3 text-center hoverPointer" onClick={() => navigate('/login')}>Already have an accounts? <span color='primary'>Login</span> </p>
              </Col>
              <Col>
              </Col>
            </Row>
            {message !="processing" && message ? <CustomAlert color={colorV} className={`font-weight-light mx-3 mb-0  ${colorV === "warning" ? "animate__animated animate__fadeInDown animate__faster" : "animate__animated animate__shakeX animate__faster"}`}>{message}</CustomAlert> : ""}
          </Container>
        </div>
      </Container>
    </>
  );

}

const CustomAlert = styled(Alert)`
  position: absolute;
  bottom: 1rem;
  min-width: 40%;
`

export default SignUp;